import { memo } from "react";
import Button from "../button/Button";
import type { IconName } from "@/components/icons/icons";

export interface SecondaryButtonProps {
  label: string;
  colour: "black" | "red" | "white";
  size?: "small" | "medium" | "medium-l" | "large";
  disabled?: boolean;
  onClick?: (() => void) | ((data: any) => void);
  icon?: IconName;
  iconPosition?: "left" | "right";
  width?: string;
  iconClassName?: string;
  buttonType?: "button" | "submit" | "reset";
  dataTestid?: string;
}

const SecondaryButton = ({
  label,
  colour = "red",
  size,
  disabled = false,
  onClick = () => {},
  icon,
  iconPosition,
  iconClassName,
  width,
  buttonType = "button",
  dataTestid,
}: SecondaryButtonProps) => {
  return (
    <Button
      dataTestid={dataTestid}
      label={label}
      size={size}
      type={`secondary-${colour}`}
      width={width}
      icon={icon}
      iconPosition={iconPosition}
      disabled={disabled}
      onClick={onClick}
      iconClassName={iconClassName}
      buttonType={buttonType}
    />
  );
};

export default memo(SecondaryButton);
